const anchornav = () => {
  const links = document.querySelectorAll(".banner-anchor-nav-link");

  if (window.location.hash === "#versionnotes") {
    const target = document.querySelector("#anchor-54");
    console.log(target);
    if (target) {
      const top = target.getBoundingClientRect().top - 100;
      console.log("top", top);
      setTimeout(() => {
        window.scrollTo({ top, behavior: "smooth" });
      }, 200);
    }
  }

  for (const link of links) {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const target = document.querySelector(link.getAttribute("href"));
      const top = target.getBoundingClientRect().top - 100;
      window.scrollTo({ top, behavior: "smooth" });
    });
  }
};

export default anchornav;
